export default __webpack_public_path__ + "static/media/eu-flag.42634896.svg";